//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('requisitionCreate', {
//        templateUrl: 'views/components/views/requisitionCreate/requisitionCreate.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'requisitionCreateService', function ($stateParams, stateService, requisitionCreateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockKeynoFrom = $stateParams.stock_keyno_from;
//            let stockKeynoTo = $stateParams.stock_keyno_to;
            
//            vm.model = {
//                stockPlaceNameFromButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockget', { stock_keyno: vm.model.edit.stock_keyno_from }) }
//                ],
//                stockPlaceNameToButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockget', { stock_keyno: vm.model.edit.stock_keyno_to }) }
//                ],
//                edit: {},
//                lockedCreate: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await requisitionCreateService.getEdit({
//                    stock_keyno_from: stockKeynoFrom,
//                    stock_keyno_to: stockKeynoTo
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.createChanges = function () {
//                vm.model.lockedCreate = true;

//                requisitionCreateService.createRequisition(vm.model.edit).then(() => {
//                    vm.model.lockedCreate = false;

//                    stateService.back('/' + 'stockget' + '/' + vm.model.edit.stock_keyno_to);
//                }, () => vm.model.lockedCreate = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
